import React  from "react";
import Wizard from "./page/Wizard";

export function WizardPage () {
    return <Wizard/>
}
